<template>
    <div class="mc-select-tabs">
        <div class="mc-select-tabs__bar">
            <!--标签页标题-->
            <div
                :class="tabCls(item)"
                v-for="(item, index) in navList"
                @click.stop="handleChange(index)">
                {{item.label}}
            </div>
        </div>
        <div class="mc-select-tabs__content">
            <!--这里的slot就是嵌套的pane-->
            <slot></slot>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'base-selectbox-tabs',
        props: {
            value: {
                type: [String, Number]
            }
        },
        data(){
            return{
                currentValue: this.value,
                // 用于渲染tabs的标题
                navList: []
            }
        },
        watch: {
            value(val){
                this.currentValue = val;
            },
            currentValue(){
                // 在当前选中的tab发生变化时，更新pane的显示状态
                this.updateStatus();
            }
        },
        methods: {
            tabCls(item){
                return [
                    'mc-select-tabs__tab',
                    {
                        // 当前选中的tab添加一个class
                        'is-active': item.name === this.currentValue
                    }
                ]
            },
            getTabs(){
                // 通过遍历子组件，得到所有的pane组件
                return this.$children.filter(function (item) {
                    return item.$options.name === 'pane';
                })
            },
            updateNav(){
                this.navList = [];
                this.getTabs().forEach((pane, index) => {
                    this.navList.push({
                        label: pane.label,
                        name: pane.name || index
                    });
                    // 如果没有给 pane 设置 name，默认设置它的索引
                    if(!pane.name) pane.name = index;
                    if(index === 0){
                        if(!this.currentValue){
                            this.currentValue = pane.name || index;
                        }
                    }
                })

                this.updateStatus();
            },
            updateStatus(){
                var tabs = this.getTabs();
                // 显示当前选中的tab对应的pane组件，隐藏没有选中的
                tabs.forEach((tab) => {
                    return tab.show = tab.name === this.currentValue;
                })
            },
            // 点击tab标题时触发
            handleChange(index){
                var nav = this.navList[index];
                var name = nav.name;
                // 改变当前选中的tab，并触发下面的watch
                this.currentValue = name;
                // 更新 value
                this.$emit('input', name);
                // 触发一个自定义事件，供父级使用
                this.$emit('click', name);
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/base-selectbox-tabs.vue